/*
 * Stop-gap navigation relabeling.
 *
 * The brand name and English-locale labels are admin-managed in the Shopify
 * navigation. Until the merchant edits the menu in admin (Online Store →
 * Navigation), this script normalises three things:
 *
 *   1. Typos: "VIST US" → "Visit us", "LOWINKYS" → "Lowinsky's"
 *   2. German nav titles: "BESUCHT UNS" / "ÜBER UNS" / "MEDIEN & GALERIE"
 *      → "Visit" / "About" / "Gallery"
 *   3. German facet labels: "VERFÜGBARKEIT" / "PREIS" → "Availability" / "Price"
 *
 * To remove this file, fix the labels in the Shopify admin and delete the
 * <script> tag in layout/theme.liquid.
 */
(function () {
  var isDe = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0
    || /^\/de(\/|$)/.test(window.location.pathname);
  var labels = isDe ? {
    '/pages/visit-us': 'Café',
    '/pages/about': 'Über uns',
    '/pages/gallery': 'Galerie'
  } : {
    '/pages/visit-us': 'Visit',
    '/pages/about': 'About',
    '/pages/gallery': 'Gallery'
  };
  var TYPO_RE = /\bVIST US\b/gi;
  var BRAND_RE = /LOWINKYS/g;

  function replaceTyposInSubtree(root) {
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (!v) continue;
      var nv = v.replace(TYPO_RE, 'Visit us').replace(BRAND_RE, "Lowinsky's");
      if (nv !== v) n.nodeValue = nv;
    }
  }

  function hrefMatches(anchor, path) {
    var h = anchor.getAttribute('href');
    if (!h) return false;
    try {
      var p = new URL(h, window.location.origin).pathname.replace(/\/$/, '') || '/';
      var want = path.replace(/\/$/, '') || '/';
      return p === want;
    } catch (e) {
      return false;
    }
  }

  function setLeadingTextNode(el, value) {
    for (var c = el.firstChild; c; c = c.nextSibling) {
      if (c.nodeType === 3) {
        c.nodeValue = value;
        return;
      }
    }
    el.insertBefore(document.createTextNode(value), el.firstChild);
  }

  function relabelScope(scope) {
    if (!scope) return;
    replaceTyposInSubtree(scope);

    Object.keys(labels).forEach(function (path) {
      scope.querySelectorAll('a').forEach(function (a) {
        if (a.dataset.relabeled) return;
        if (a.dataset.primaryNav === 'true') return;
        if (a.querySelector('svg, img')) return;
        if (!hrefMatches(a, path)) return;
        a.textContent = labels[path];
        a.dataset.relabeled = '1';
      });
    });

    scope.querySelectorAll('summary').forEach(function (s) {
      var t = (s.textContent || '').trim().toUpperCase();
      if (t === 'BESUCHT UNS' || t === 'BESUCHEN SIE UNS') setLeadingTextNode(s, 'Visit');
      else if (t === 'ÜBER UNS') setLeadingTextNode(s, 'About');
      else if (t === 'MEDIEN & GALERIE' || t === 'MEDIEN UND GALERIE') setLeadingTextNode(s, 'Gallery');
    });
  }

  function relabelFacets() {
    var sels = '.facets__summary-label, .mobile-facets__summary span, .facets__summary, summary.facets__summary, .facet-checkbox label, .facets__display summary, .facets-vertical summary span';
    document.querySelectorAll(sels).forEach(function (node) {
      var text = (node.textContent || '').trim().toUpperCase();
      if (text === 'VERFÜGBARKEIT') setLeadingTextNode(node, 'Availability');
      else if (text === 'PREIS') setLeadingTextNode(node, 'Price');
      else if (text === 'FILTER UND SORTIEREN' || text === 'FILTER & SORTIEREN') setLeadingTextNode(node, 'Filter and sort');
      else if (text === 'SORTIEREN NACH:' || text === 'SORTIEREN NACH') setLeadingTextNode(node, 'Sort by:');
    });
    // Also walk text nodes inside facets containers and replace exact strings
    var roots = document.querySelectorAll('.facets-container, facet-filters-form, .facets-vertical-form, .collection-filters');
    roots.forEach(function (r) {
      var w = document.createTreeWalker(r, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        var v = n.nodeValue;
        if (!v) continue;
        var nv = v.replace(/\bPreis\b/g, 'Price').replace(/\bVerfügbarkeit\b/g, 'Availability').replace(/\bFilter und sortieren\b/gi, 'Filter and sort').replace(/\bSortieren nach\b/gi, 'Sort by');
        if (nv !== v) n.nodeValue = nv;
      }
    });
  }

  function relabelAll() {
    document
      .querySelectorAll('header, sticky-header, header-drawer, .menu-drawer, .header__inline-menu, .header__submenu')
      .forEach(relabelScope);
    relabelFacets();
  }

  /* One-shot pass after the page is interactive. The original implementation
     ran a MutationObserver on document.body subtree:true — that fires on every
     DOM change anywhere on the page. Header markup is static after first paint;
     facets re-render only inside .facets-container on filter changes, so we
     scope observers narrowly. */
  function init() {
    relabelAll();

    document.querySelectorAll('.facets-container, facet-filters-form').forEach(function (target) {
      new MutationObserver(relabelFacets).observe(target, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
